module.exports = require("core-js/modules/esnext.map.key-of.js");